import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { getCompany } from 'api/resources/company';
import type { Company as TCompany } from 'legacy/lib/api/types/Company';
import { ECacheKeys } from 'cache/CacheKeys';
import { useEffect } from 'react';
import { displayAlertError } from 'legacy/utilities/Response';

export const useGetCompany = (options?: UseQueryOptions<TCompany>) => {
	const query = useQuery<TCompany>({
		queryKey: [ECacheKeys.Company],
		queryFn: getCompany,
		refetchInterval: false,
		refetchOnWindowFocus: false,
		staleTime: Infinity,
		cacheTime: Infinity,
		...(options || {}),
	});

	useEffect(() => {
		if (query.error) {
			displayAlertError(
				'An error occurred fetching the company information, please try again'
			);
		}
	}, [query.error]);

	return query;
};
